// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import { __ } from '@oat-sa-private/ui-core';

__('No entities found in the file');
__('Student performance');
__('Opened on');
__('Closed on');
__('Test taker');
__('Test takers');
__('Groups');
__('Sessions');
__('Group performance');
__('login');
__('metadata.ssn');
__('metadata.duf');
__('metadata.dnumber');
__('metadata.passport');
__('metadata.user.ssn');
__('metadata.user.duf');
__('metadata.user.dnumber');
__('metadata.user.passport');
__('email');
__('standardScoring');
__('appeal');
__('appealScoring');
__('standard');
__('nn-NO');
__('nb-NO');
__('Collapse Menu');
__('Expand Menu');
__('Session template is in use');
